// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"139":"e35e9646","230":"f1e6ac00","532":"a7412d39","857":"b29d1e4c"}[chunkId] + ".chunk.css";
};